import React from 'react';
import styles from './WidgetBox.module.css';

export type WidgetTitleProps = React.ComponentProps<'div'> & {
    title: string;
    leftElement?: React.ReactNode;
    rightElement?: React.ReactNode;
};

function WidgetTitle({ title, leftElement, rightElement, ...props }: WidgetTitleProps): JSX.Element {
    return (
        <div className={styles.header} {...props}>
            <div className={styles.titleWrap}>
                {leftElement ? <span className={styles.titleIcon}>{leftElement}</span> : null}
                <label className={styles.title}>{title}</label>
            </div>
            {rightElement}
        </div>
    );
}

export default WidgetTitle;
